import { motion } from 'framer-motion'
import { industries } from '../data/mockData'
import { Building2 } from 'lucide-react'
import IndustryCard from '../compenents/IndustryCard'

const Industries = () => {
  return (
    <div className="min-h-screen pt-24 pb-20">
      <div className="max-w-7xl mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <div className="inline-flex items-center justify-center w-20 h-20 bg-green-100 rounded-full mb-6">
            <Building2 className="w-10 h-10 text-green-600" />
          </div>
          <h1 className="text-5xl md:text-6xl font-bold text-gradient mb-6">Secteurs d'Application</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            ECOTHERM répond aux besoins spécifiques de quatre secteurs industriels majeurs avec des solutions adaptées et performantes.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {industries.map((industry, index) => (
            <motion.div
              key={industry.id}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.15 }}
            >
              <IndustryCard industry={industry} />
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.6 }}
          className="mt-20 bg-gradient-to-br from-green-600 to-green-700 rounded-3xl p-12 text-white"
        >
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">Pourquoi Choisir ECOTHERM ?</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
              <div>
                <div className="text-5xl font-bold mb-2">30%</div>
                <p className="text-lg opacity-90">Économie d'énergie</p>
              </div>
              <div>
                <div className="text-5xl font-bold mb-2">A2</div>
                <p className="text-lg opacity-90">Classement feu</p>
              </div>
              <div>
                <div className="text-5xl font-bold mb-2">100%</div>
                <p className="text-lg opacity-90">Naturel</p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  )
}

export default Industries